module.exports = __webpack_public_path__ + "cake.svg?156ee40c248fcbc22639977e2573414b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cake.svg
// module id = 192
// module chunks = 0